export function TalentSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/talent.svg'"></ng-include>`
    }
}